import React from 'react'
import { AppBar, IconButton, Toolbar, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useIntl } from 'react-intl'

interface ModalHeaderProps {
  titleKey: string
  onClose: () => void
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ titleKey, onClose }) => {
  const { formatMessage } = useIntl()

  return (
    <AppBar position="static" color="transparent" elevation={0} sx={{ borderBottom: '1px solid #E0E0E0', mb: 4 }}>
      <Toolbar sx={{ justifyContent: 'space-between', px: 0 }}>
        <Typography component="span" variant="subtitle1" fontWeight={600} fontSize={14} color="text.primary">
          {formatMessage({ id: titleKey })}
        </Typography>
        <IconButton edge="end" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}
